/**
 * orga-app-api - einlasskontrolle-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EinlasskontrolleBenutzerZugriff { 
    ist_aktiv?: boolean;
    ist_protokollierung_aktivierbar?: boolean;
    ist_protokollierung_auswertung_erlaubt?: boolean;
    mandant_id: string;
    modified_on_utc: Date;
}

